<template>
  <video v-if="testOn && testBBB" controls autoplay />
</template>

<script>
export default {
  name: "tryBBB",
  props: {
    testOn: {
      type: Boolean,
      required: true,
    },
    testBBB: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss">

</style>
